import qs from "qs";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import { ICategory } from "./models";

export const GetBonusesCategoriesApi = async () => {
  const { data } = await api.post<ICategory[]>(
    API_ROUTES.BONUS_CATEGORIES,
    qs.stringify({ ...defaultOptions() })
  );

  return data;
};
